// Global navigation utility functions
// These functions can be imported and used in any component

import { INSTALL_PAGE_PATH } from '../constants/urls';

export { INSTALL_PAGE_PATH };

export const scrollToTop = () => {
  window.scrollTo(0, 0);
};

export const scrollToElement = (elementId: string, behavior: 'smooth' | 'auto' = 'smooth') => {
  const element = document.getElementById(elementId);
  if (element) {
    element.scrollIntoView({ 
      behavior,
      block: 'start'
    });
  }
};

export const scrollToDemo = () => {
  scrollToElement('demo');
};

export const scrollToFeatures = () => {
  scrollToElement('features');
};

export const scrollToTrial = () => {
  scrollToElement('install-cta');
};

export const scrollToContact = () => {
  scrollToElement('contact');
};

// Navigation functions that work with React Router
export const createNavigationFunctions = (navigate: (path: string) => void) => ({
  goToHome: () => {
    navigate('/');
    scrollToTop();
  },
  
  goToPricing: () => {
    navigate(INSTALL_PAGE_PATH);
    scrollToTop();
  },
  
  goToHomeAndScrollToDemo: () => {
    navigate('/');
    // Small delay to ensure page loads before scrolling
    setTimeout(() => scrollToDemo(), 100);
  },
  
  goToHomeAndScrollToFeatures: () => {
    navigate('/');
    setTimeout(() => scrollToFeatures(), 100);
  },
  
  goToHomeAndScrollToTrial: () => {
    navigate('/');
    setTimeout(() => scrollToTrial(), 100);
  }
});

// Export the function creator so components can use it
export default createNavigationFunctions;
